import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ROUTES } from '@/constants/routes';

/** Shown when an anonymous request tries to reach an authenticated-only page — redirects to login. */
export function UnauthorizedPage() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ minHeight: '100vh', textAlign: 'center', p: 3 }}
    >
      <Typography variant="h1" fontWeight={700}>
        401
      </Typography>
      <Typography variant="h6">Please sign in to continue.</Typography>
      <Button component={RouterLink} to={ROUTES.login} variant="contained">
        Sign in
      </Button>
    </Stack>
  );
}
